"use strict";
/*jslint browser: true */
var pjax = require('./pjax')

var pageURL = window.location.href;
window.helper = window.helper || {};

var autocomplete = require("jquery-ui/ui/widgets/autocomplete"),
	Cookies = require("js-cookie"),
	hostSplit = location.hostname.split('.').reverse(),
	gtm = require('./gtm-events'),
	cookieDomain = hostSplit.length > 1 ? '.' + hostSplit[1] + '.' + hostSplit[0] : location.hostname; //temp fix

//!!! only call on full page reload or direct link
//Since the pjax handel the page navigate, this will only execute if page fully refreshed or direct link
$(window).on("load", function () {
	helper.getAmbassadorCookies();
})
//!!! only call on full page reload or direct link

helper.createCookie = function (name, value, options) {
	var opts = options || {};
	opts.domain = cookieDomain;
	Cookies.set(name, value, opts);
};

helper.readCookie = function (name) {
	return Cookies.get(name);
};

helper.readSessionStorage = function () {
	var showPromo = (typeof sessionStorage !== undefined) ? sessionStorage.getItem('showPromo') : null;
	if (showPromo === null) {
		$('.promo-bar').show();
	}else if (showPromo === 'false') {
		$('.promo-bar').hide();
	}

	var showAlert = (typeof sessionStorage !== undefined) ? sessionStorage.getItem('showAlert') : null;
	if (showAlert === null) {
		$('.page-alert--yellow').show();
	}
}

/**
 * set item into session storage
 */
helper.setSessionStorage = function (name, value) {
	if (sessionStorage) {
		sessionStorage.setItem(name, value);
	}
}

var usOrcanadaZipRegex = /^([0-9]{5}|[A-Z][0-9][A-Z] ?[0-9][A-Z][0-9])$/;
helper.isValidateZipCode = function (zip) {
	return usOrcanadaZipRegex.test(zip);
};

// gets add on product from session storage
helper.getAddOn = function (p) {
	if (sessionStorage) {
		return sessionStorage.getItem('addOn_' + p);
	};
};

helper.zipAutoComplete = function (options) {
	var selector = options.selector,
		onSelect = function (zip, isManual) {
			if (helper.isValidateZipCode(zip)) {
				helper.createCookie('userLocation', zip, {
					expires: 365
				});
				if (options.onSelect) options.onSelect(zip);
				if (isManual) {
					gtm.analyticsEvent('Zip Widget', 'manual selection ' + selector + zip, pageURL);
				} else {
					gtm.analyticsEvent('Zip Widget', 'auto selection ' + selector + zip, pageURL);
				}
			} else {
				if (options.onError) options.onError(zip);
				gtm.analyticsEvent('Zip Widget', 'invalid entry ' + selector + zip, pageURL);
			}
		},
		element = $(selector);
	/* jshint ignore:start */
	if (!element || !element.length > 0) return;
	/* jshint ignore:end */
	element.keyup(function (e) {
		e.preventDefault();
		var value = element.val();
		var code = e.keyCode || e.which;
		if (code === 13) {
			onSelect(value, true);
			return false;
		}

		if (!value) {
			return null;
		} else {
			$.ajax({
				url: api.zipurl + value + '/5',
				type: "GET",
				async: true,
				dataType: "json",
			}).done(function (data) {
				var canadaZipSuggestions = [];
				$.each(data.canadaZipSuggestions, function (k, v) {
					canadaZipSuggestions.push({
						label: v.zipcode + ' (' + v.state + ')',
						value: v.zipcode
					});
				});
				$(selector).autocomplete({
					appendTo: (options.append) ? "#special-event-modal" : "#signupform",
					source: canadaZipSuggestions,
					select: function (event, ui) {
						if (ui && ui.item && ui.item.value) {
							element.val(ui.item.value);
							onSelect(ui.item.value);
						}
					}
				});
			});
		}
	});
};

/**
 * valiate zip again api service
 * zip - zipcode value
 * field - input field to apply the error class
 */
helper.zipValidation = function (zip, field) {
	var result = false;
	if (!_.isNil(zip) && !_.isNull(zip) && zip !== "") {
		$.ajax({
			url: api.zipValidation + "/" + zip,
			type: "GET",
			async: false,
			dataType: "json",
			success: function (data) {
				if (data && data.error) {
					field.addClass("error");
					result = false;
				} else {
					result = true;
				}
			}
		});
	} else {
		result = false;
	}
	return result;
}

//base on zipcode & product ids get new pricing info.
helper.getProductPrices = function (ids, zip) {
	var output;
	$.ajax({
		url: api.productPriceSearch + "/" + ids.join(',') + "/" + zip,
		type: "GET",
		async: false,
		dataType: "json",
		success: function (data) {
			output = data;
		}
	});
	return output;
}

//Course Details api
helper.getcourseDetails = function (id) {
	var output;
	$.ajax({
		url: api.courseDetails + "/" + id,
		type: "GET",
		async: false,
		dataType: "json",
		success: function (data) {
			output = data;
		}
	});
	return output;
}

//Grad year api.
helper.getGradYear = function (selector) {
	$.ajax({
		url: api.gradYear,
		type: "GET",
		async: false,
		dataType: "json",
	}).done(function (data) {
		$.each(data.data, function (k, v) {
			$(selector).append("<option value=" + v + ">" + v + "</option>");
		});
	});
}

//base on Longitude & Latitude to get position
helper.getPosition = function (longitude, latitude) {
	var output;
	$.ajax({
		url: api.geoUrl + "?latitude=" + latitude + "&longitude=" + longitude,
		type: "GET",
		async: false,
		dataType: "json",
		success: function (data) {
			output = data.response;
		}
	});
	return output;
}

helper.currentURLWithoutQS = function () {
	return location.protocol + '//' + location.host + location.pathname;
};

//Header search-box
helper.search = function (q) {
	var term = q.trim(); //remove before and after space

	if (term !== undefined || term !== "") {
		if ((!/\s/g.test(term)) && (term.length >= 7 && term.length <= 11) && (term.match(/[A-z]{2,5}\d+[0-9A-z]/) || term.match(/[\d]{11}/))) {
			pjax.loadUrl('/class/' + term);
		} else {
			pjax.loadUrl('/search?q=' + term);
		}
	}
};

helper.validateEmail = function (email) {
	var re = /^(([^<>()\[\]\\.,;:+'\s@"]+(\.[^<>()\[\]\\.,;:+'\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
};

helper.validatePhone = function (phone) {
	var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
	return re.test(phone);
};

helper.getUrlParameter = function (name) {
	name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
	var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
	var results = regex.exec(location.search);
	return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

//Loop over the obj and remove any empty, undefined, or null entry
helper.removeEmpty = function (obj) {
	Object.keys(obj).forEach(function (key) {
		(obj[key] && typeof obj[key] === 'object') && removeEmpty(obj[key]) || (obj[key] === undefined || obj[key] === '' || obj[key] === 'null') && delete obj[key]
	});
	return obj;
};

// FORM VALIDATIONS (7/27/17 NOT in Use yet)
helper.formValidateEmail = function (id) {
	email = $('#' + id + '-field-email').val();
	if (helper.validateEmail(email)) {
		return true;
	} else {
		$('#' + id + ' .form-field-email').addClass("error");
		$('#' + id + ' label[for="' + id + '-field-email"]').addClass("error");
		return false;
	}
}

helper.formValidateParentEmail = function (id) {
	parentEmail = $('#' + id + '-field-parent-email');
	if ((parentEmail.length === 1) && (parentEmail.val() !== "")) {
		if (helper.validateEmail(parentEmail.val())) {
			return true;
		} else {
			$('#' + id + '-field-parent-email').addClass("error");
			$('#' + id + ' label[for="' + id + '-field-parent-email"]').addClass("error");
			return false;
		}
	} else {
		return true;
	}
};

helper.formCheckNull = function (id) {
	var $inputs = $('#' + id + '.form-default :required');
	var out = true;

	$inputs.each(function () {
		var value = $(this).val();
		if (value === null || value === "") {
			$(this).addClass("error");
			$("label[for=" + this.id + "]").addClass("error");
			out = false;
		}
	});
	return out;
};

helper.formValidateTestDate = function (id) {
	var dateField = $('#' + id + '-field-date');
	if ((dateField.length === 1) && (dateField.val() !== "")) {
		var dateString = moment($('#' + id + '-field-date').val());
		if (dateString._isValid) {
			var now = moment();
			var future = moment("2050-12-31");
			if ((dateString < now) || (dateString > future)) {
				$('#' + id + ' .form-field-date').addClass("error");
				$('#' + id + ' label[for="' + id + '-field-date"]').addClass("error");
				return false;
			} else {
				return true;
			}
		}
	} else {
		return true;
	}
};

helper.formClearError = function (thisInput, thisID) {
	$(thisInput).removeClass("error");
	$("label[for=" + thisID + "]").removeClass("error");
}

helper.formValidateZip = function (id) {
	zip = $('#' + id + '-field-zip').val();
	if (helper.isValidateZipCode(zip)) {
		return true;
	} else {
		$('#' + id + ' .form-field-zip').addClass("error");
		$('#' + id + ' label[for="' + id + '-field-zip"]').addClass("error");
		return false;
	}
};

//get query param from url and return value
helper.getURLQueryParam = function (key) {
	var href = window.location.href;
	var reg = new RegExp('[?&]' + key + '=([^&#]*)', 'i');
	var string = reg.exec(href);
	return string ? string[1] : null;
}

// drop these cookies so SF can pick up these things.
helper.getAmbassadorCookies = function () {
	var r = /^[a-zA-Z0-9-]*$/
	var mbsy = helper.getURLQueryParam('mbsy');
	//add 1 over check if there is ambassador then we do 2 less if statement
	if (mbsy !== null) {
		if (r.test(mbsy)) {
			helper.createCookie('ambassador_mbsy', mbsy, {
				expires: 365
			});
		}
		var campaignid = helper.getURLQueryParam('campaignid');
		if (campaignid !== null && r.test(campaignid)) {
			helper.createCookie('ambassador_campaignid', campaignid, {
				expires: 365
			});
		}



		var mbsy_source = helper.getURLQueryParam('mbsy_source');
		if (mbsy_source !== null && r.test(mbsy_source)) {
			helper.createCookie('ambassador_mbsy_source', mbsy_source, {
				expires: 365
			});
		}
	}

}


//////////////////
// WEBPACK FOOTER
// ./public/js/lib/helper.js
// module id = 77
// module chunks = 0